module.exports = __webpack_public_path__ + "resources/img/img_awesome_secure_trust3_en.a91b344398d8a7a6406617a2ec15d760.png";